<div class="w-full max-w-6xl mx-auto p-6">
  @if (error()) {
    <div class="bg-red-50 border border-red-200 rounded-lg p-4 mb-6 flex items-center gap-2">
      <i class="pi pi-exclamation-triangle text-red-600"></i>
      <p class="text-red-800">{{ error() }}</p>
    </div>
  }

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <p-card styleClass="sale-form-card">
      <ng-template pTemplate="header">
        <div class="px-4 py-3 border-b border-slate-200 bg-slate-50/50">
          <div class="flex items-center gap-3">
            <p-button
              icon="pi pi-arrow-left"
              [rounded]="true"
              [text]="true"
              severity="secondary"
              type="button"
              (onClick)="cancel()"
              pTooltip="Volver al listado"
              tooltipPosition="bottom"
            />
            <h2 class="text-lg font-semibold text-slate-900 flex items-center gap-2 min-w-0">
              <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-indigo-100 text-indigo-600">
                <i class="pi pi-percentage"></i>
              </span>
              <span class="truncate">{{ isEditMode() ? 'Editar impuesto' : 'Nuevo impuesto' }}</span>
            </h2>
          </div>
        </div>
      </ng-template>

      <p-tabs [value]="activeTab()" (valueChange)="onTabChange($event)">
        <p-tablist>
          @for (tab of tabs; track tab.value) {
            <p-tab
              [value]="tab.value"
              [disabled]="tab.value === 'auditoria' && !isEditMode()"
              class="flex items-center gap-2! text-inherit"
            >
              <i [class]="tab.icon"></i>
              <span>{{ tab.label }}</span>
            </p-tab>
          }
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel value="general">
            <div class="grid grid-cols-1 gap-4 mt-4">
              <div class="flex flex-col gap-1">
                <p-floatlabel class="w-full" variant="on">
                  <p-select
                    formControlName="taxSelection"
                    inputId="taxSelection"
                    [options]="taxOptions()"
                    optionLabel="displayName"
                    dataKey="id"
                    class="w-full"
                    [invalid]="(form.get('taxSelection')?.invalid ?? false) && (form.get('taxSelection')?.touched ?? false)"
                  >
                    <ng-template #item let-option>
                      <span class="block truncate">{{ option.displayName || option.taxKey }}</span>
                    </ng-template>
                  </p-select>
                  <label for="taxSelection">Impuesto SAT <span class="text-red-500">*</span></label>
                </p-floatlabel>
                <small class="text-slate-500">Selecciona un impuesto del catálogo fiscal.</small>
              </div>

              <div class="flex flex-col gap-1">
                <p-floatlabel class="w-full" variant="on">
                  <p-select
                    formControlName="applicationType"
                    inputId="applicationType"
                    [options]="taxApplicationOptions"
                    optionLabel="label"
                    optionValue="value"
                    class="w-full"
                  />
                  <label for="applicationType">Tipo de aplicación</label>
                </p-floatlabel>
              </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
              <div class="flex flex-col gap-1">
                <p-floatlabel class="w-full" variant="on">
                  <p-inputNumber
                    id="taxRate"
                    formControlName="taxRate"
                    [min]="0"
                    [max]="100"
                    mode="decimal"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="6"
                    [allowEmpty]="true"
                    fluid
                  />
                  <label for="taxRate">Tasa (%)</label>
                </p-floatlabel>
                <small class="text-slate-500">% de impuestos (0 a 100)</small>
              </div>
              <div class="flex flex-col gap-1">
                <p-floatlabel class="w-full" variant="on">
                  <p-inputNumber
                    id="taxAmount"
                    formControlName="taxAmount"
                    [min]="0"
                    mode="decimal"
                    currency="MXN"
                    locale="es-MX"
                    inputStyleClass="text-right"
                    [minFractionDigits]="2"
                    [maxFractionDigits]="4"
                    [allowEmpty]="true"
                    fluid
                  />
                  <label for="taxAmount">Monto</label>
                </p-floatlabel>
                <small class="text-slate-500">Cuota de impuesto</small>
              </div>
            </div>

            <div class="flex flex-col gap-1 mt-4">
              <label class="block text-sm font-medium text-slate-700 mb-2">Tipo de cobro</label>
              <p-selectButton
                formControlName="collectionType"
                [options]="taxCollectionTypeOptions"
                optionLabel="label"
                optionValue="value"
                [allowEmpty]="false"
              />
              <small class="text-slate-500">Determina si es retención o traslado.</small>
            </div>
          </p-tabpanel>

          <p-tabpanel value="auditoria">
            @if (activeTab() === 'auditoria') {
              <app-entity-audit-panel
                entityType="ProductTax"
                [entityId]="editingId()"
                entityLabel="impuesto"
              />
            }
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>

      <ng-template pTemplate="footer">
        <div class="!mt-4 flex flex-wrap items-center justify-end gap-4 mt-1 !p-4 !-m-5 bg-gray-50 p-2 border-t border-slate-200">
          <p-button label="Cancelar" severity="secondary" (onClick)="cancel()" type="button" />
          @if (activeTab() === 'general') {
            <p-button
              [label]="isEditMode() ? 'Guardar cambios' : 'Crear impuesto'"
              icon="pi pi-check"
              type="submit"
              [loading]="loading()"
              [disabled]="form.invalid || loading()"
            />
          }
        </div>
      </ng-template>
    </p-card>
  </form>
</div>
